// extracted by mini-css-extract-plugin
export default {"container":"SSNPlaceholder_container__bdiD9","content":"SSNPlaceholder_content__T+RVK","dots":"SSNPlaceholder_dots__xA54d","eyeIcon":"SSNPlaceholder_eyeIcon__D5iwg"};